module.exports = __webpack_public_path__ + "img/institution.56ae3b11.png";